import { render, staticRenderFns } from "./settings-workflow-notice.vue?vue&type=template&id=2aefdb10&scoped=true"
import script from "./settings-workflow-notice.vue?vue&type=script&lang=js"
export * from "./settings-workflow-notice.vue?vue&type=script&lang=js"
import style0 from "./settings-workflow-notice.vue?vue&type=style&index=0&id=2aefdb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefdb10",
  null
  
)

export default component.exports